import {SET, DELETED, UPDATED, ADDED} from './actionTypes';
import update from "immutability-helper";

const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.smtps;

    case ADDED:
      return {
        ...state,
        [action.smtp.id]: action.smtp
      };

    case UPDATED:
      return update(state, {
        [action.smtp.id]: {
          $set: action.smtp
        }
      });

    case DELETED:
      return update(state, {$unset: [action.smtp.id]});

    default:
      return state;
  }
};